export default "__VITE_ASSET__BiUiXlqQ__"